import { styled } from '@mui/system'
import { Autocomplete, CardHeader, generateUtilityClasses, Grid, Typography } from '@mui/material'
import React from 'react'
import { TextField } from '../../../../../../../../../ui'
import DropdownFieldSearch from '../../../../../../../../../ui/DropdownFieldSearch'
import { useSelector } from 'react-redux'
import { selectDropdownByName, selectDropdownByNameActiveOnly } from '../../../../../../../../../services'
import { Field } from 'react-final-form'
import { TextField as MuiTextField } from '@mui/material'

const classes = generateUtilityClasses('Grid', ['root', 'row', 'optionalText'])

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.row}`]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
  [`& .${classes.optionalText}`]: {
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 400,
    Size: '0.8750em',
    fontStyle: 'italic',
    lineHeight: '1.1875em',
    marginLeft: theme.spacing(1),
  },
}))

interface Props {}

const TradeVehicleForm = ({}: Props) => {
  const carOdometerType = useSelector((state) => selectDropdownByName(state, 'CarOdometerType'))
  const carBodyType = useSelector((state) => selectDropdownByNameActiveOnly(state, 'CarBodyType'))
  const exteriorColor = useSelector((state) => selectDropdownByName(state, 'CarExteriorColor'))
  const interiorColor = useSelector((state) => selectDropdownByName(state, 'CarInteriorColor'))

  return (
    <>
      <CardHeader title='Trade Vehicle' />
      <Grid container spacing={2} padding={3}>
        <Grid item xs={6}>
          <TextField name='StockNumber' label='Stock Number (Optional)' fullWidth />
        </Grid>
        <Grid item xs={6}>
          <TextField name='VIN' label='VIN' fullWidth />
        </Grid>
        <Grid item xs={2}>
          <TextField name='Year' label='Year' fullWidth />
        </Grid>
        <Grid item xs={4}>
          <TextField name='Make' label='Make' fullWidth />
        </Grid>
        <Grid item xs={6}>
          <TextField name='Model' label='Model' fullWidth />
        </Grid>
        <Grid item xs={6}>
          <TextField name='Trim' label='Trim' fullWidth />
        </Grid>
        {carBodyType && (
          <Grid item xs={6}>
            <DropdownFieldSearch name='Body' label='Body' options={carBodyType} optionKey='ID' optionValue='BodyType' autoComplete='off' />
          </Grid>
        )}
        <Grid item xs={3}>
          <TextField name='Mileage' label='Mileage' fullWidth />
        </Grid>
        {carOdometerType && (
          <Grid item xs={3}>
            <DropdownFieldSearch
              name='Odometer'
              label='Odometer Type'
              fullWidth
              options={carOdometerType?.ReturnData}
              optionKey='ID'
              optionValue='OdometerType'
              initialValue={1}
              disableClearable
            />
          </Grid>
        )}
        <Grid item xs={6}>
          <Field name='Color'>
            {(props) => (
              <Autocomplete
                freeSolo
                onChange={(e, value) => {
                  props.input.onChange(value)
                }}
                value={props.input.value}
                options={exteriorColor?.ReturnData?.map((option: any) => option.Color) ?? []}
                renderInput={(params) => (
                  <MuiTextField
                    onChange={(e) => {
                      props.input.onChange(e.target.value)
                    }}
                    {...params}
                    label='Color'
                  />
                )}
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={6}>
          <Field name='InteriorColor'>
            {(props) => (
              <Autocomplete
                freeSolo
                onChange={(e, value) => {
                  props.input.onChange(value)
                }}
                value={props.input.value}
                options={exteriorColor?.ReturnData?.map((option: any) => option.Color) ?? []}
                renderInput={(params) => (
                  <MuiTextField
                    onChange={(e) => {
                      props.input.onChange(e.target.value)
                    }}
                    {...params}
                    label='Interior Color'
                  />
                )}
              />
            )}
          </Field>
        </Grid>
      </Grid>
    </>
  )
}

export default TradeVehicleForm
